
if (!window.car_rent) window.car_rent = {};


car_rent.getDaysBetweenDates = (dateString1, dateString2) => {
    // Parse the date strings into Date objects
    const date1 = new Date(dateString1.split(" ")[0]);
    const date2 = new Date(dateString2.split(" ")[0]);
    const timeDifference = Math.abs(date2 - date1);
    // Convert milliseconds to days (1000 ms * 60 sec * 60 min * 24 hrs)
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    
    return daysDifference;
}